/* eslint-disable  import/no-named-as-default, css-modules/no-unused-class  */
import { FC, useEffect, useRef } from 'react';
import styles from './progresses.module.scss';

const LessonProgressBorder: FC<{ percentage: number; size?: number; lineWidth?: number }> = ({
    percentage,
    size = 133,
    lineWidth = 7
}: {
    percentage: number;
    size?: number;
    lineWidth?: number;
}) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        if (canvasRef.current) {
            const canvas = canvasRef.current;
            const context = canvas.getContext('2d');
            if (context) {
                const centerX = size / 2;
                const centerY = size / 2;
                const radius = Math.min(centerX, centerY) - lineWidth / 2;
                const startAngle = -Math.PI / 2;
                const endAngle = startAngle + (percentage / 100) * 2 * Math.PI;
                context.clearRect(0, 0, size, size);
                context.strokeStyle = '#FB86B6';
                context.lineWidth = lineWidth;
                context.beginPath();
                context.arc(centerX, centerY, radius, startAngle, endAngle);
                context.stroke();
            }
        }
    }, [percentage]);

    return <canvas ref={canvasRef} className={styles.circle}></canvas>;
};

export default LessonProgressBorder;
